// src/api/currencies.ts
import { opsHttp } from "../auth/apiClient.ts";

/** Валюта из справочника. Скрытые (isActive=false) в этот список не попадают. */
export interface CurrencyDto {
  id: number;
  code: string;
  name: string;
  symbol?: string | null;
  isActive: boolean;
  sortOrder: number;
}

/** Валюты, доступные для создания заявки. Скрытые админом сюда не приходят. */
export async function getCurrencies(): Promise<CurrencyDto[]> {
  const { data } = await opsHttp.get<CurrencyDto[]>("/api/Currencies");
  return data ?? [];
}
